import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
const recap = ['6 томова', '5 бонуса', '240 страна', '1–8. разред'];
const reassurances = ['Одмах на мејл', 'PDF за штампу', '7 дана гаранције'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15d40c8mskuoe">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jcd76hp3ycfp" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1edipxk6sgvxp">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t3g5xcukefbt">
          Ваши часови физичког могу бити <em className="text-red-700" data-id="element-118" data-mp="1o4dbsng4htim">спремни већ данас.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="224o47ux2zg5w">
          Уместо да тражите игре, сами смишљате сваку вежбу и проводите недеље увече у планирању, имате организован пакет за физичко за целу школску годину. Више времена за оно што је заиста важно:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="s5qnxvjvh4to">
          Ваши ученици. Ваши часови. Ваш живот ван школе.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="122v9pu9t2y9y">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="163fbjb5bqq2f">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="162m8ol9hkkpk">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1fujoy6fcq2v5">Једнократна уплата – без претплате.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1ktd0htb2vjso">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1kstk4h12t3gr" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="1pszei4yqd42j">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="1tuudh2t6v5d5">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3qu5q68v05ppm" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}